import script from "./BitrixGuideSidePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./BitrixGuideSidePanel.vue?vue&type=script&setup=true&lang=js"

import "./BitrixGuideSidePanel.vue?vue&type=style&index=0&id=75422c09&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75422c09"]])

export default __exports__